import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './PublishedDate.scss';

const PublishedDate = ({ meta, display, className }) => 
    <time className={cn("published-date", className)} dateTime={meta}>{display}</time>;

PublishedDate.propTypes = {
    meta: PropTypes.string,
    display: PropTypes.string,
    className: PropTypes.string
};

export default PublishedDate;



// WEBPACK FOOTER //
// ./src/components/PublishedDate/PublishedDate.jsx